import type { FaireProductEntity } from "../../entity_types/product";

export const p_gww4gxsqxu: FaireProductEntity = {
  token: "p_gww4gxsqxu",
  type: "product",
  name: "Bananarama",
  brandToken: "b_mukk4ka83q",
  brandName: "The Penny Candy Store",
  imageUrl:
    "https://cdn.faire.com/fastly/88eb9551fca62aa482f723ad939039d42748ec49054e265156527644c0ed996e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f7e2bd8806d812294c557a5703d19bdbb9ed933b528f7b38e90db03a90bcede.jpeg",
    "https://cdn.faire.com/fastly/210321406fd03cf1536ad42ab3c19eef94feac152a3cb4fb3d8b095c06bae311.jpeg",
    "https://cdn.faire.com/fastly/e185ff7ac9b104d54f16b3b947be62fe3985e1cb0801ec63ae8bdbbfeb9617aa.jpeg",
    "https://cdn.faire.com/fastly/077c8eccbf7f5bcbf974a5825424b49a69315d4f1bd3e5de4a3e80578d7dae37.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Relish in Bananarama, a Hard Candy from The Penny Candy Store. Using recyclable packaging, these candies balance tradition and sustainability, promising a 12-24 month shelf life.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:05.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
